import { Route } from 'react-router-dom';

import { Page } from '@app/routes';
import UserDataFormPage from '@app/pages/UserDataFormPage';
import InstructionsPage from '@app/pages/InstructionsPage';
import HomePage from '@app/pages/HomePage';
import ShopPage from '@app/pages/ShopPage';
import CookiesPage from '@app/pages/CookiesPage';
import DiamondsPage from '@app/pages/DiamondsPage';
import ProfilePage from '@app/pages/ProfilePage';
import ReferralTreePage from '@app/pages/ReferralTreePage';
import EditProfilePage from '@/app/pages/ProfileEditPage';
import TasksPage from '@app/pages/TasksPage';
import FriendsPage from '@app/pages/FriendsPage';
import UserProfilePage from '@app/pages/UserProfilePage';
import MatrixChannelPage from '@app/pages/MatrixChannelPage';
import WithdrawalPage from '@app/pages/WithdrawalPage';
import SettlementsPage from '@app/pages/SettlementsPage';
import RoadmapPage from '@app/pages/RoadmapPage';
import DailyCardDescriptionPage from '@app/pages/DailyCardDescriptionPage';
import DailyCardPreviewPage from '@app/pages/DailyCardPreviewPage';
import DailyCardResultPage from '@app/pages/DailyCardResultPage';
import DailyEnergyPage from '@app/pages/DailyEnergyPage';
import DailyEnergyDescriptionPage from '@app/pages/DailyEnergyDescriptionPage';
import CompatibilityCalculatorPage from '@app/pages/CompatibilityCalculator';
import CognitionPage from '@app/pages/CognitionPage';
import StoneAbilitiesPage from '@app/pages/StoneAbilitiesPage';
import SettlementDetailsPage from '@app/pages/SettlementDetailsPage';
import BalanceHistory from '@app/pages/BalanceHistory';
import { DevelopmentPage } from '@app/pages/DevelopmentPage';

export const UserRoutes = (
  <>
    <Route path={Page.USER_DATA_FORM} element={<UserDataFormPage />} />
    <Route path={Page.INSTRUCTIONS} element={<InstructionsPage />} />
    <Route path={Page.HOME} element={<HomePage />} />
    <Route path={Page.SHOP} element={<ShopPage />} />
    <Route path={Page.COOKIES_SHOP} element={<CookiesPage />} />
    <Route path={Page.DIAMONDS_SHOP} element={<DiamondsPage />} />
    <Route path={Page.COGNITION} element={<CognitionPage />} />
    <Route path={Page.STONE_ABILITIES} element={<StoneAbilitiesPage />} />
    <Route path={Page.SETTLEMENTS_SHOP} element={<SettlementsPage />} />
    <Route path={Page.SETTLEMENT_DETAILS} element={<SettlementDetailsPage />} />
    <Route path={Page.FRIENDS} element={<FriendsPage />} />
    <Route path={Page.PROFILE} element={<ProfilePage />} />
    <Route path={Page.REFERRAL_TREE} element={<ReferralTreePage />} />
    <Route path={Page.EDIT_PROFILE} element={<EditProfilePage />} />
    <Route path={Page.USER_PROFILE} element={<UserProfilePage />} />
    <Route path={Page.BALANCE_HISTORY} element={<BalanceHistory />} />
    <Route path={Page.TASKS} element={<TasksPage />} />
    <Route path={Page.MATRIX_CHANNEL} element={<MatrixChannelPage />} />
    <Route path={Page.WITHDRAWAL} element={<WithdrawalPage />} />
    <Route path={Page.ROADMAP} element={<RoadmapPage />} />
    <Route path={Page.DAILY_CARD_DESCRIPTION} element={<DailyCardDescriptionPage />} />
    <Route path={Page.DAILY_CARD_PREVIEW} element={<DailyCardPreviewPage />} />
    <Route path={Page.DAILY_CARD_RESULT} element={<DailyCardResultPage />} />
    <Route path={Page.DAILY_ENERGY} element={<DailyEnergyPage />} />
    <Route path={Page.DAILY_ENERGY_DESCRIPTION} element={<DailyEnergyDescriptionPage />} />
    <Route path={Page.COMPATIBILITY_CALCULATOR} element={<CompatibilityCalculatorPage />} />
    <Route path={Page.DEVELOPMENT} element={<DevelopmentPage />} />
  </>
);
